import React, { useState, useEffect } from 'react';
import { Col } from 'reactstrap';
//Components
import ModalCustomized from '../../../../components/Modal/Modal';
import TextField from '../../../../components/TextField/TextField';
//Api
import ManutencaoOrdemColeta_api from '../../../../api/ManutencaoOrdemColeta_api';
import programacaoColeta_api from '../../../../api/programacaoColeta_api';
//Helpers
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../helpers/message';
//Estado inicial da variavel de controle do transbordo/transferencia
function initialStateTransbordoTransferencia(id = "") {
    return {
        tbOrdemColeta_Id: id.toString(),
        tbVeiculos_Id: "",
        tbVeiculos_Id_Selected: "",
        tbUsuarios_Operador_Id: "",
        tbUsuarios_Operador_Id_Selected: "",
    }
}
export default function TransbordoETransferencia({ acao, toggleModal, openModal, ordem, setLoading, btnVoltar }) {
    //Guarda os erros dos campos que não foram preenchidos corretamente
    const [errors, setErrors] = useState({});
    //Armazena os dados do select de motoristas
    const [motoristas, setMotoristas] = useState([]);
    //Armazena os dados do select de veiculos
    const [veiculos, setVeiculos] = useState([]);
    //Guarda os dados necessarios para fazer a transferencia / transbordo
    const [transbordoTranferencia, setTransbordoTranferencia] = useState(initialStateTransbordoTransferencia(ordem.id));
    //Campos obrigatorios de transbordo/transferencia de coletas
    const camposTransbordoTransferencia = [
        objCampo({ name: "tbVeiculos_Id_Selected", required: true }),
        objCampo({ name: "tbUsuarios_Operador_Id_Selected", required: true }),
    ]
    //Valida os campos para realizar transbordo/transferencia
    const validaTransbordoTranferencia = () => {
        const _errors = validarCampos(transbordoTranferencia, camposTransbordoTransferencia);
        setErrors(_errors[0]);
        return _errors[1].length > 0;
    }
    //Ação realizada a transferencia de coletas pendentes
    const transferenciaDeColetas = () => {
        if (validaTransbordoTranferencia()) {
            return;
        }
        setLoading(true);
        ManutencaoOrdemColeta_api.TransferenciaDeColetasPendentes(transbordoTranferencia).then(response => {
            showMessage("Sucesso", "Transferência realizada com sucesso!", "success", btnVoltar);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
            .finally(f => setLoading(false));
    }
    //Ação realizada para fazer o transbordo de carga
    const transbordoDeCarga = () => {
        if (validaTransbordoTranferencia()) {
            return;
        }
        setLoading(true);
        ManutencaoOrdemColeta_api.TransbordoDeCarga(transbordoTranferencia).then(response => {
            showMessage("Sucesso", "Transbordo realizado com sucesso!", "success", btnVoltar);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
            .finally(f => setLoading(false));
    }
    //OnChange para os campos do transbordo / transferencia
    const onChangeTransbordoTransferencia = (e, select) => {
        const { name } = select;
        setTransbordoTranferencia({
            ...transbordoTranferencia,
            [name]: e,
            [name.replace("_Selected", "")]: e.value
        })
    }
    //Função executada ao clicar no botão de confirmar do modal
    const submitModal = () => {
        if(ordem.status == "Descarregando"){
            showMessage("Aviso", "Não é possível executar esta ação pois a ordem de coleta está com o status 'Descarregando'. Aguarde a saída do destino.", "error", null)
            return;
        }
        
        if (acao === "Transbordo de carga") {
            transbordoDeCarga();
        } else if (acao === "Transferência de coletas pendentes") {
            transferenciaDeColetas();
        }
    }
    useEffect(() => {
        //Carrega os veiculos disponiveis
        programacaoColeta_api.GetVeiculosDisponiveis(ordem.id).then(response => {
            response.data = response.data.filter(value => value.id !== ordem.tbVeiculos_Id);
            response.data = response.data.map(value => { return { value: value.id, label: value.placa } });
            setVeiculos(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
        //Carrega os motoristas disponiveis
        programacaoColeta_api.GetMotoristasDisponiveis(ordem.id).then(motoristasD => {
            let options = motoristasD.data.map(motorista => { return { value: motorista.id, label: motorista.nome } });
            if (acao === "Transferência de coletas pendentes") {
                options = options.filter(value => {
                    return value.value !== ordem.tbUsuarios_Operador_Id;
                });
            }
            setErrors({});
            setMotoristas(options);

        }).catch(e => showMessage("Aviso", e.message, "error", null));
    }, [acao]);
    return (
        <ModalCustomized title={acao} isOpen={openModal} toggle={toggleModal} btnClose={() => {
            setTransbordoTranferencia(initialStateTransbordoTransferencia(ordem.id))
            toggleModal();
        }} btnAction={"Confirmar"} onClickBtnAction={submitModal} btnActionColor="success">
            <div>
                <Col md="12" lg="12">
                    <TextField invalid={errors.tbVeiculos_Id_Selected ? true : false} label="* Veículo" type={"select"} searchable options={veiculos} value={transbordoTranferencia.tbVeiculos_Id_Selected} name={"tbVeiculos_Id_Selected"} onChange={onChangeTransbordoTransferencia} />
                </Col>
                <Col md="12" lg="12">
                    <TextField invalid={errors.tbUsuarios_Operador_Id_Selected ? true : false} label="* Motorista" type={"select"} searchable options={motoristas} value={transbordoTranferencia.tbUsuarios_Operador_Id_Selected} name={"tbUsuarios_Operador_Id_Selected"} onChange={onChangeTransbordoTransferencia} />
                </Col>
            </div>
        </ModalCustomized>
    );
}